// Remove Cookies Shortcode
(function() {
    Alpine.data('remove_cookies', () => ({
        showButton: false,
        showDeletionMessage: false,

        init() {
            var externalContentCookies = getCookiesWithPrefix("always-load-");
            if (externalContentCookies.length > 0) {
                this.showButton = true;
            }
        },

        deleteCookies() {
            deleteCookiesWithPrefix("always-load-");
            this.showDeletionMessage = true;
            this.showButton = false;
        }
    }));
})();